import FieldWrapper from "../components/FieldWrapper";
import { TitleFieldType } from "../types/feedbackFields.types";

const TitleField = ({ field }: { field: TitleFieldType }) => {
  return (
    <FieldWrapper field={field} showLabel={false}>
      <h3>{field.text}</h3>
    </FieldWrapper>
  );
};
export default TitleField;
